import React, { useState } from 'react';
import { Check, Star } from 'lucide-react';
import { pricingPlans } from '../mockData';
import { Button } from './ui/button';
import KYCForm from './KYCForm';

const Pricing = () => {
  const [isKYCOpen, setIsKYCOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('');

  const handlePlanClick = (planName) => {
    setSelectedPlan(planName);
    setIsKYCOpen(true);
  };

  return (
    <>
      <section id="pricing" className="bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Choose Your{' '}
            <span className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
              Trading Plan
            </span>
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto mb-8">
            Flexible pricing for traders at every level
          </p>
          <div className="flex flex-wrap gap-4 justify-center text-sm">
            <div className="flex items-center gap-2 text-slate-300">
              <Check className="w-5 h-5 text-cyan-400" />
              <span>30-Day Money Back Guarantee</span>
            </div>
            <div className="flex items-center gap-2 text-slate-300">
              <Check className="w-5 h-5 text-cyan-400" />
              <span>24/7 Customer Support</span>
            </div>
            <div className="flex items-center gap-2 text-slate-300">
              <Check className="w-5 h-5 text-cyan-400" />
              <span>Lifetime Free Updates</span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {pricingPlans.map((plan, index) => (
            <div
              key={index}
              className={`relative bg-gradient-to-br from-slate-900/80 to-slate-900/50 backdrop-blur-sm border rounded-2xl p-8 transition-all duration-300 hover:transform hover:scale-105 ${
                plan.recommended
                  ? 'border-cyan-500/50 shadow-xl shadow-cyan-500/20 lg:-mt-4 lg:mb-0'
                  : 'border-slate-800/50 hover:border-cyan-500/30'
              }`}
            >
              {plan.recommended && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <div className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-full shadow-lg">
                    <Star className="w-4 h-4 text-white fill-white" />
                    <span className="text-white font-semibold text-sm">Most Popular</span>
                  </div>
                </div>
              )}

              <div className="text-center mb-8 pt-4">
                <h3 className="text-2xl font-bold text-white mb-2">{plan.name}</h3>
                <p className="text-slate-400 text-sm mb-6">{plan.description}</p>
                <div className="text-3xl font-bold text-white mb-1">{plan.price}</div>
                {plan.name === 'Institutional' && (
                  <p className="text-slate-500 text-sm">Volume-based discounts available</p>
                )}
              </div>

              <div className="space-y-4 mb-8">
                {plan.features.map((feature, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <div className="w-5 h-5 rounded-full bg-cyan-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <Check className="w-3 h-3 text-cyan-400" />
                    </div>
                    <span className="text-slate-300 text-sm">{feature}</span>
                  </div>
                ))}
              </div>

              <button
                onClick={() => handlePlanClick(plan.name)}
                className={`block w-full py-4 rounded-lg font-semibold transition-all duration-300 text-center ${
                  plan.recommended
                    ? 'bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white shadow-lg shadow-cyan-500/30 hover:shadow-cyan-500/50'
                    : 'bg-slate-800/50 hover:bg-slate-800 text-white border border-slate-700/50 hover:border-cyan-500/50'
                }`}
              >
                {plan.name === 'Institutional' ? 'Contact Sales' : 'Get Started'}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
    
    <KYCForm 
      isOpen={isKYCOpen} 
      onClose={() => setIsKYCOpen(false)} 
      selectedPlan={selectedPlan} 
    />
  </>
  );
};

export default Pricing;
